export default __webpack_public_path__ + "static/all-device-7de6a92222efb44d98dbc1d3197db216.webp";